HoneyMoney      = require('models/virtual.coffee').HoneyMoney
Account         = require 'models/account.coffee'
AccountCategory = require 'models/account_category.coffee'
Virtual         = require('models/virtual.coffee').Virtual
ReservesForecast = require('models/reserves_forecast.js').default

store = {}
store.state =
  ui:
    account_categories:
      edited: null
    accounts:
      edited: null
    virtuals:
      edited: null
    accounts_virtuals_changed_tooltip: []

store.getters =
  virtuals: (state) -> _.orderBy(state.user.virtuals, 'position', 'desc')
  accounts: (state) -> _.orderBy(state.user.accounts, 'category', 'position')
  accounts_visible: (s, getters) ->
    all_accounts = _.map getters.account_categories_visible, (cat) -> cat.children()
    _.flatten(all_accounts)
  account_last_used: (state, getters) ->
    last_used_account_id = state.ui.transactions.current.last_used_account_id
    if last_used_account_id
      getters.accounts_find(last_used_account_id)
  accounts_in_budget: (state) -> state.user.accounts.filter((ac) -> ac.is_in_budget == true)
  accounts_find: (state) -> (id) -> _.find(state.user.accounts, { id: id })
  virtuals_find: (state, getters) ->
    (id) ->
      return getters.hm if id == -1
      return _.find(state.user.virtuals, { id: id })
  account_categories: (state) -> _.orderBy state.user.account_categories, 'position'
  account_categories_visible: (_state, getters) -> getters.account_categories.filter((ac) -> ac.selectable)
  account_categories_find: (state) -> (id) -> _.find(state.user.account_categories, {id: id})
  virtual_categories: (state, getters) ->
    hm_and_reserves = if HM.is_russian then 'ХаниМани и Резервы' else 'HoneyMoney and Reserves'
    funds           = if HM.is_russian then 'Фонды' else 'Funds'
    goals           = if HM.is_russian then 'Цели' else 'Goals'
    hidden          = if HM.is_russian then 'Скрытые ' else 'Hidden '
    [
      { name: hm_and_reserves, children: (-> [getters.hm, getters.rs]), type: 'hm_and_reserves', hidden: false }
      { name: funds,           children: (-> getters.not_hidden_funds), type: 'funds', hidden: false }
      { name: goals ,          children: (-> getters.not_hidden_goals), type: 'goals', hidden: false }
      { name: hidden + funds , children: (-> getters.hidden_funds)    , type: 'hidden_funds', hidden: true }
      { name: hidden + goals , children: (-> getters.hidden_goals)    , type: 'hidden_goals', hidden: true }
    ]
  virtual_categories_visible: (_state, getters) -> getters.virtual_categories.filter((vcat) -> vcat.hidden == false)
  hm: (state, getters) ->
    new HoneyMoney
      balance: getters.accounts_sum - getters.rs?.balance - getters.funds_sum - getters.goals_sum
      currency: getters.default_currency
  accounts_sum: (state, getters) ->
    Math.round(_.sumBy getters.accounts_in_budget, (acc) -> acc.universalBalance(getters.default_currency))
  all_accounts_sum: (state, getters) ->
    Math.round(_.sumBy getters.accounts, (acc) -> acc.universalBalance(getters.default_currency))
  rs:               (_state, getters) -> getters.virtuals.filter((vir) -> vir.isRS())[0]
  goals:            (_state, getters) -> getters.virtuals.filter((vir) -> vir.isGoal())
  funds:            (_state, getters) -> getters.virtuals.filter((vir) -> vir.isFund())
  goals_sum:        (_state, getters) -> Math.round(_.sumBy getters.goals, (vir) -> vir.universalBalance(getters.default_currency))
  funds_sum:        (_state, getters) -> Math.round(_.sumBy getters.funds, (vir) -> vir.universalBalance(getters.default_currency))
  not_hidden_goals: (_state, getters) -> getters.goals.filter((v) -> v.hidden == false )
  hidden_goals:     (_state, getters) -> getters.goals.filter((v) -> v.hidden == true  )
  not_hidden_funds: (_state, getters) -> getters.funds.filter((v) -> v.hidden == false )
  hidden_funds:     (_state, getters) -> getters.funds.filter((v) -> v.hidden == true  )
  forecast:         (_state, getters) -> ReservesForecast(getters)

store.mutations =
  ###*
   * Update item in the store
   * @param  {[STATE]} state
   * @param  {[Object]} payload.item record to update
   * @param  {[Object]} payload.item_type account/virtual/transaction
  ###
  '💾 UPDATE_STORE_ITEM': (state, payload) ->
    item     = payload.item
    records  = state.user[payload.item_type]
    if (original = _.find(records, { id: item.id }))
      _.merge original, item
    else
      records.push item

  '💾 DESTROY_STORE_ITEM': (state, payload) ->
    item = payload.item
    collection = payload.item_type
    _.remove state.user[payload.item_type], { id: item.id }
    state.user[payload.item_type] = _.clone(state.user[payload.item_type])

  'ACCOUNTS/EDIT': (state, account) -> state.ui.accounts.edited = account
  'ACCOUNT_CATEGORIES/EDIT': (state, account_category) -> state.ui.account_categories.edited = account_category
  'VIRTUALS/EDIT': (state, virtual) -> state.ui.virtuals.edited = virtual

  '💾 ACCOUNTS_VIRTUALS/UPDATE': (state, payload) ->
    state.ui.accounts_virtuals_changed_tooltip = []
    old_hm_balance = HM.store.getters.hm.balance

    new_accounts = _.map Object.values(payload.accounts), (acc) -> new Account(acc)
    for acc in new_accounts
      old_account = HM.store.getters.accounts_find(acc.id)
      state.ui.accounts_virtuals_changed_tooltip.push
        name:        acc.name
        currency:    acc.currency
        old_balance: old_account?.balance
        new_balance: acc.balance
        credit_limit: acc.credit_limit
    state.user.accounts = _.unionBy new_accounts, state.user.accounts, 'id'

    new_virtuals = _.map Object.values(payload.virtuals), (acc) -> new Virtual(acc)
    for virtual in new_virtuals
      old_virtual = HM.store.getters.virtuals_find(virtual.id)
      state.ui.accounts_virtuals_changed_tooltip.push
        name:        virtual.name
        currency:    virtual.currency
        old_balance: old_virtual?.balance
        new_balance: virtual.balance
    state.user.virtuals = _.unionBy new_virtuals, state.user.virtuals, 'id'

    if HM.store.getters.hm.balance != old_hm_balance
      state.ui.accounts_virtuals_changed_tooltip.push
        name:        HM.store.getters.virtuals_find(-1).name
        currency:    HM.store.getters.hm.currency
        old_balance: old_hm_balance
        new_balance: HM.store.getters.hm.balance

    state.ui.accounts_virtuals_changed_tooltip = state.ui.accounts_virtuals_changed_tooltip.filter (el) ->
      el.old_balance != el.new_balance

store.actions =
  sortAccounts: (context, args) ->
    HM_API.sort_accounts(args.category_id, args.account_ids).then (res) ->
      for account in res.data.accounts
        context.commit '💾 UPDATE_STORE_ITEM',
          item_type: 'accounts'
          item: account

  sortVirtuals: (context, args) ->
    HM_API.sort_virtuals(args.virtual_ids).then (res) ->
      for virtual in res.data.virtuals
        context.commit '💾 UPDATE_STORE_ITEM',
          item_type: 'virtuals'
          item: virtual

  saveAccount: (context, account) ->
    HM_API.save_account_virtual('account', account).then (res) ->
      context.commit '💾 UPDATE_STORE_ITEM',
        item_type: 'accounts'
        item: _.merge(account, res.data.account)
  saveVirtual: (context, virtual) ->
    HM_API.save_account_virtual('virtual', virtual).then (res) ->
      context.commit '💾 UPDATE_STORE_ITEM',
        item_type: 'virtuals'
        item: _.merge(virtual, res.data.virtual)

  destroyAccount: (context, account) ->
    HM_API.destroy_account_virtual('account', account).then (res) ->
      context.commit '💾 DESTROY_STORE_ITEM',
        item: account
        item_type: 'accounts'
  destroyVirtual: (context, virtual) ->
    HM_API.destroy_account_virtual('virtual', virtual).then (res) ->
      context.commit '💾 DESTROY_STORE_ITEM',
        item: virtual
        item_type: 'virtuals'

  newAccount: (context) -> context.commit 'ACCOUNTS/EDIT', Account.newRecord(context.state.user)
  newVirtual: (context) -> context.commit 'VIRTUALS/EDIT', Virtual.newRecord(context.state.user)


store.actions.showTransactionsHistory = (context, payload) ->
  context.commit 'TRANSACTIONS/LIST/SET_FILTER', payload.filter
  from = context.getters.first_transaction_date
  to   = context.getters.last_transaction_date
  HM.router.push { name: 'list', query: { dates: "#{from}--#{to}" } }
  HM.track "#{payload.mode}-history"

################################
###### ACCOUNT CATEGORIES ######
################################

store.actions.newAccountCategory = (context) ->
  context.commit 'ACCOUNT_CATEGORIES/EDIT', new AccountCategory({})

store.actions.saveAccountCategory = (context, payload) ->
  categories = context.state.user.userdata.settings.account_categories

  account_category = payload.account_category
  categories[account_category.id] = account_category
  context.commit '💾 UPDATE_STORE_ITEM',
    item_type: 'account_categories'
    item: account_category

  if payload.positions && payload.positions.length
    for id, position in payload.positions
      categories[id].position = position + 1
      context.commit '💾 UPDATE_STORE_ITEM',
        item_type: 'account_categories'
        item: categories[id]

  HM_API.update_user({ settings: context.state.user.userdata.settings })

store.actions.destroyAccountCategory = (context, account_category) ->
  delete context.state.user.userdata.settings.account_categories[account_category.id]
  HM_API.update_user({ settings: context.state.user.userdata.settings }).then ->
    context.commit '💾 DESTROY_STORE_ITEM',
      item: account_category
      item_type: 'account_categories'

store.actions.sortAccountCategories = (context, categories_ids) ->
  categories = context.state.user.userdata.settings.account_categories

module.exports = store

